import { groupAccountMapEntityName } from '@juvare/contact-management/backend/features/groups/shared';
export function getMissionAccountFilter({ missionOrganizationSharing, missionGroupSharing, }) {
    const missionAccountFilter = [{ column: 'systemStatus', op: '=', value: 'active' }];
    if (missionOrganizationSharing && missionOrganizationSharing.length > 0) {
        missionAccountFilter.push({
            column: 'orgMembership',
            op: 'overlap',
            value: missionOrganizationSharing,
        });
    }
    if (missionGroupSharing && missionGroupSharing.length > 0) {
        missionAccountFilter.push({
            op: 'in',
            idSubFilter: {
                entity: groupAccountMapEntityName,
                column: 'accountId',
                filter: [{ column: 'groupId', op: 'in', value: missionGroupSharing }],
            },
        });
    }
    return missionAccountFilter;
}
